import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class CancelTransactionModal extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    cancelTransaction: PropTypes.func.isRequired
  }

  handleDelete = () => {
    const { transaction } = this.props
    this.props.cancelTransaction(transaction)
    this.props.history.replace('/home')
  }
  componentDidMount() {}
  render() {
    const { transaction } = this.props
    const title =
      transaction.type === 'POOL'
        ? transaction.pool.table.name
        : transaction.bar.name
    return (
      <ModalWrapper
        open
        onOk={this.handleDelete}
        maxWidth={'xs'}
        title={`Annuler ${title}`}
        okText="Annuler la vente"
        okDisabled={false}>
        <Grid container direction="column" justify="center">
          <Grid item xs={12}>
            <Typography variant="subheading" gutterBottom>
              {`Êtes-vous sur de vouloir annuler la vente sur ${title} ?`}
              <Typography variant="caption">
                Cette action est irréversible
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withRouter(withStyles(styles)(CancelTransactionModal))



// WEBPACK FOOTER //
// ./src/components/modals/client/CancelTransactionModal.js